import React from 'react';

const LinkedIn = ({ className }) => (
  <svg className={className} width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.0223 0.928711H1.70451C0.757562 0.928711 0 1.68612 0 2.53821V21.9468C0 22.7989 0.757562 23.5563 1.70451 23.5563H21.0223C21.9693 23.5563 22.7269 22.7989 22.7269 21.9468V2.53821C22.7269 1.68612 21.9693 0.928711 21.0223 0.928711ZM6.72336 20.2427H3.40903V9.44958H6.72336V20.2427ZM5.11354 7.93476C4.0719 7.93476 3.12494 7.08267 3.12494 5.94655C3.12494 4.81044 3.9772 3.95835 5.11354 3.95835C6.15519 3.95835 7.10214 4.81044 7.10214 5.94655C7.10214 7.08267 6.15519 7.93476 5.11354 7.93476ZM19.4125 20.148H16.0982V14.8461C16.0982 13.6153 16.0982 11.9112 14.299 11.9112C12.4998 11.9112 12.3104 13.3313 12.3104 14.6568V20.0533H8.99605V9.44958H12.121V10.8697H12.2157C12.6892 10.0176 13.8255 9.07087 15.4353 9.07087C18.8444 9.07087 19.5072 11.3431 19.5072 14.2781V20.148H19.4125Z"
      fill="currentColor"
    />
  </svg>
);

export default LinkedIn;
